
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { SdsForm } from "soft_digi";
import { SdsFormElementProps } from "soft_digi/dist/sdforms/SdsFromInterFace";
import * as Yup from "yup";
import { DESIG_URLS } from "../../api/AdminUrls";
import { useSiteContext } from "../../contexts/SiteProvider";
import { role_get_select } from "../../services/site/SelectBoxServices";
import { post } from "../../services/smartApiService";
import { yupResolver } from "@hookform/resolvers/yup";

interface HeaderProps {
  loadTableData: () => void;
  dataIn: any;
}
const schema = Yup.object({
  designation_name: Yup.string()
    .required("Required")
    .min(2, "Name must be at least 2 characters"),
    base_salary: Yup.number()
    .required("Required")
});
const DesigForm: React.FC<HeaderProps> = ({ loadTableData, dataIn }) => {
  const {
    control,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues:dataIn,
    resolver: yupResolver(schema), 
  });
  const { closeModal } = useSiteContext();

  const [allRole, setAllRole] = useState([]);

  useEffect(() => {
    role_get_select((data: any) => setAllRole(data));
  }, []);


  const onSubmit = (data: any) => {
    let url = DESIG_URLS.INSERT;
    if (dataIn.ID !== undefined) {
      data["id"] = dataIn.ID;
      url = DESIG_URLS.UPDATE;
    }
    const subscription = post(url, data).subscribe((response) => {
      loadTableData();
      closeModal();
    });
    return () => {
      subscription.unsubscribe();
    };
  };

  const elements: SdsFormElementProps[] = [
    {
      type: "TEXT_BOX",
      width: 6,
      name: "designation_name",
      element: {
        label: "Name",
        isRequired: true,
     
      },
    },
    {
      type: "TEXT_BOX",
      width: 6,
      name: "base_salary",
      element: {
        label: "Basic Salary",
        isRequired: true,
      },
    },

    {
      type: "BUTTON",
      width: 12,
      name: "submit_button",
      class_name: "has-text-right",
      element: {
        classList: ["button", "smart-action-button"],
        label: dataIn.ID ? "Update" : "Add",
        onClick: handleSubmit(onSubmit),
      },
    },
  ];
  return (
    <>
      <div className="sd-hims-input">
        <SdsForm elements={elements} errors={errors} control={control} />
      </div>
    </>
  );
};

export default DesigForm;
